import { render, staticRenderFns } from "./BindInfo.vue?vue&type=template&id=79a0e047"
import script from "./BindInfo.vue?vue&type=script&lang=js"
export * from "./BindInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports